export const FETCH_ALLEYE_PROVIDER_KPI = 'FETCH_ALLEYE_PROVIDER_KPI';
export const FETCH_ALLEYE_PROVIDER_KPI_SUCCESS = 'FETCH_ALLEYE_PROVIDER_KPI_SUCCESS';
export const FETCH_ALLEYE_PROVIDER_KPI_FAILED = 'FETCH_ALLEYE_PROVIDER_KPI_FAILED';
export const LOADING_ALLEYE_PROVIDER_KPI = 'LOADING_ALLEYE_PROVIDER_KPI';
